import React, { useContext } from 'react';
import './TopCasinoGames.css';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';
import { CasinoThumbnail } from '../../../../verticals/src/components/GameThumbnails/Casino/CasinoThumbnail';
import { AsgFwContext } from '../../../../verticals/src/contexts';
import { PlayerService } from '../../../../shared/src/services/player.service';
import { useNeoCmsFeatureRelatedGamesHook } from '../../../../shared/src/hooks/use-neo-cms-feature-related-games.hook';
import { NeoCmsGameCategoryFeatureNamesEnum } from '../../../../shared/src/enums/neo-cms-game-category-feature-names.enum';

export const TopCasinoGames = () => {
    const featureName = NeoCmsGameCategoryFeatureNamesEnum.LANDING_PAGES_GAMES_BLOCK;
    const { featureRelatedGames } = useNeoCmsFeatureRelatedGamesHook(featureName);
    const { prioritizedGames } = useSelector(state => state.casino);
    const {
        brandName,
        isMobile,
        isNeoCmsIntegrationEnabled,
    } = useSelector(state => state.app);
    const AsgFw = useContext(AsgFwContext);
    const playerLoginAction = PlayerService.showLoginOrRegistration;
    const { t } = useTranslations();

    const casinoGames = isNeoCmsIntegrationEnabled
        ? featureRelatedGames
        : prioritizedGames?.casino;
    const limitedCasinoGames = casinoGames?.slice(0, 12);

    return (<section className="homepage-games-container">
        <div className="homepage-games-title">
            {brandName ? brandName : ''} {`${t('homeTop')} ${AsgFw.getCountryName()}`}
        </div>

        <div className="homepage-games-items">
            {limitedCasinoGames && limitedCasinoGames.map(({ id, images, name }, key) =>
                <CasinoThumbnail
                    key={key}
                    id={id}
                    images={images}
                    name={name}
                    isMobile={isMobile}
                    openGameHandler={playerLoginAction}
                />)}
        </div>
    </section>);
};
